import './tw-button.styles.scss';
import React, { FC} from 'react';
import { Button } from 'antd';
import { ButtonProps } from 'antd/lib/button';


/**
 * TwButtonProps
 *
 * @memberof TwButton
 */
interface TwButtonProps extends Omit<ButtonProps, 'size'|'type'> {

    /**
     * overwritten size prop from Ant buttons. our sizes are used to define custom styling 
     */
    size?: 'mini' | 'small' | 'default' | 'large';

    /**
     * overwritten type prop from Ant buttons. our types are a list of default custon stylings
     */
    type?: 'solid' | 'outline' | 'link' | 'clear' | 'empty' | 'secondary' | 'cancel' | 'secondaryCTA';

};

/**
 * A Simple Tailwind Button Component
 */
export const TwButton: FC<TwButtonProps> = (
    {
        size = "default",
        type = "solid",
        ...props
    }
) => {

    // Renders a Ant Button overwritten with our default stylings 
    return (
        <div className="tw-button" >
            <Button className={ (type + " " + size)} {...props}> {props.children} </Button>
        </div>
    )
};
